import React from 'react';
import { Box, Heading, Page, PageContent } from 'grommet';
import { useLoaderData } from 'react-router-dom';
import QueryString from 'qs';
import { API } from '@enrich/shared-lib';

export const Conversation = () => {
    const conversation = useLoaderData();
    const users = conversation.data.attributes.users.data;
    console.log(conversation);

    return (
        <Page
            kind="full"
            pad={{ top: '30px', horizontal: 'medium', bottom: '30px' }}>
            <PageContent gap="medium">
                <Box justify="between">
                    <Heading level="2">Conversation</Heading>
                    <Box>
                        {users.map((user) => {
                            return (
                                <Box
                                    key={user.id}
                                    background="white"
                                    pad="small"
                                    round="6px"
                                    border={{
                                        color: 'enrich-green-light',
                                        size: '3px',
                                    }}
                                    gap="small">
                                    {user.attributes.email}
                                </Box>
                            );
                        })}
                    </Box>
                </Box>
            </PageContent>
        </Page>
    );
};

export async function loader({ params }) {
    const query = QueryString.stringify({
        populate: {
            message: true,
            users: {
                populate: ['contact'],
            },
        },
    });

    try {
        const response = await API.get(
            `/api/conversations/${params.conversationId}?${query}`,
        );
        return response.data;
    } catch (error) {
        console.log(error);
        return {};
    }
}
